import { BasicEnumerable } from "../BasicEnumerable.js";
export const flatten = (source, shallow) => {
    function* iterator(source) {
        for (const item of source) {
            if (item[Symbol.iterator] !== undefined && typeof item !== "string") {
                yield* shallow ? item : iterator(item);
            }
            else {
                yield item;
            }
        }
    }
    return new BasicEnumerable(() => iterator(source));
};
